import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { FC } from "react";

import { HoursNumberFieldStyled } from "../live-map.hours-range.widget.styled";
import { useLiveMapHoursNumberField } from "./use-live-map-hours-number-field";

interface ILiveMapHoursNumberFieldProps {
  value: number;
  onChange: (value: number | undefined) => void;
  dataE2e: string;
  inputAriaLabel: string;
  decreaseAriaLabel: string;
  increaseAriaLabel: string;
}

export const LiveMapHoursNumberField: FC<ILiveMapHoursNumberFieldProps> = ({
  value,
  onChange,
  dataE2e,
  inputAriaLabel,
  decreaseAriaLabel,
  increaseAriaLabel,
}) => {
  const { handleChange, increment, decrement, isDecrementDisabled } =
    useLiveMapHoursNumberField({ value, onChange });

  return (
    <HoursNumberFieldStyled>
      <TextField
        type="number"
        size="small"
        value={value}
        aria-label={inputAriaLabel}
        onChange={handleChange}
        slotProps={{
          htmlInput: {
            min: 0,
            inputMode: "numeric",
            "data-e2e": dataE2e,
          },
          input: {
            endAdornment: (
              <InputAdornment position="end" className="hours-number-steppers">
                <IconButton
                  size="small"
                  onClick={increment}
                  aria-label={increaseAriaLabel}
                  className="hours-number-stepper-btn hours-number-stepper-btn--up"
                >
                  <KeyboardArrowUp fontSize="inherit" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={decrement}
                  disabled={isDecrementDisabled}
                  aria-label={decreaseAriaLabel}
                  className="hours-number-stepper-btn hours-number-stepper-btn--down"
                >
                  <KeyboardArrowDown fontSize="inherit" />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </HoursNumberFieldStyled>
  );
};
